import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [exitConfirmCallback, setExitConfirmCallback] = useState(null);

  const registerUnsavedChanges = (callback) => {
    setHasUnsavedChanges(true);
    setExitConfirmCallback(() => callback);
  };

  const clearUnsavedChanges = () => {
    setHasUnsavedChanges(false);
    setExitConfirmCallback(null);
  };

  const checkUnsavedChanges = (navigate, targetPath) => {
    if (hasUnsavedChanges && exitConfirmCallback) {
      exitConfirmCallback(navigate, targetPath);
      return true; // Block navigation
    }
    return false; // Allow navigation
  };

  return (
    <NavigationContext.Provider
      value={{
        hasUnsavedChanges,
        registerUnsavedChanges,
        clearUnsavedChanges,
        checkUnsavedChanges,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
